'use client';

import { ComponentProps } from 'react';
import { createPortal } from 'react-dom';

type ReactPortalComponentProps = {
    wrapperId?: string;
} & ComponentProps<'div'>;
const ReactPortalComponent = ({
    children,
    wrapperId,
}: ReactPortalComponentProps) => {
    if (typeof document === 'undefined') return null;
    const wrapper = document.getElementById(wrapperId || '');
    return <>{createPortal(children as any, wrapper || document.body)}</>;
};
export default ReactPortalComponent;
